"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    NumberFieldButton: ()=>NumberFieldButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const number_field_namespaceObject = require("@base-ui-components/react/number-field");
const index_cjs_namespaceObject = require("../IconButton/index.cjs");
const noop_cjs_namespaceObject = require("../../utils/noop.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../Tooltip/index.cjs");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const toolTipClass = 'data-disabled:cursor-not-allowed test cursor-pointer';
function NumberFieldButton({ type, tooltipProps, iconButtonProps = {}, emphasis, disabled, buttonType }) {
    const BaseUIButton = 'increment' === type ? number_field_namespaceObject.NumberField.Increment : number_field_namespaceObject.NumberField.Decrement;
    const { iconName = 'increment' === type ? 'add' : 'remove', size = 'sm', ...restProps } = iconButtonProps;
    const Node = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(BaseUIButton, {
        render: (controlProps)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.IconButton, {
                ...controlProps,
                onClick: noop_cjs_namespaceObject.noop,
                iconName: iconName,
                size: size,
                type: buttonType,
                emphasis: emphasis,
                disabled: disabled,
                ...restProps
            })
    });
    if (tooltipProps?.children) {
        const { className, ...restTooltipProps } = tooltipProps;
        const tooltipEmphasis = 'bold' !== emphasis;
        const toolTipClasses = (0, cn_cjs_namespaceObject.cn)(toolTipClass, className);
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
            ...restTooltipProps,
            emphasis: tooltipEmphasis,
            className: toolTipClasses,
            triggerNode: Node
        });
    }
    return Node;
}
exports.NumberFieldButton = __webpack_exports__.NumberFieldButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "NumberFieldButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
